require('jquery')
require('kendo-ui-all')
require('./kendo.common.min.css')
require('./kendo.metroblack.min.css')
require('./overrides.import.css')
require('./overrides.extend.css')



//////////////////
// WEBPACK FOOTER
// ./vendor/kendo-ui/index.js
// module id = 199
// module chunks = 0